// Demo Widget One data
export const dataOne = [
  5,
  33,
  5,
  45,
  5,
  10,
  5,
  20,
  5,
  1,
  18,
  12,
  5,
  10,
  5,
  20,
  8,
  64,
  57,
  7,
];

export const dataTwo = [
  1,
  18,
  12,
  5,
  10,
  5,
  20,
  8,
  75,
  80,
  60,
  5,
  10,
  5,
  20,
  8,
  80,
  75,
  7,
];

export const dataThree = [
  33,
  95,
  45,
  95,
  110,
  151,
  120,
  225,
  221,
  318,
  312,
  225,
  210,
  95,
  320,
  456,
  464,
  33,
  252,
  210,
  298,
  110,
  125,
  220,
  125,
  121,
  118,
  112,
  225,
  110,
  95,
  220,
  28,
  64,
];

export const dataFour = [
  33,
  95,
  45,
  95,
  110,
  151,
  120,
  225,
  221,
  318,
  312,
  225,
  210,
  95,
  320,
  456,
  464,
  33,
  252,
  210,
  298,
  110,
  125,
  220,
  125,
  121,
  118,
  112,
  225,
  110,
  95,
  220,
  28,
  64,
];

export const dataFive = [1, 18, 12, 5, 10, 5, 20, 8];

export const systemMessages = [
  {
    id: 64454124,
    subject: 'Welcome to Unity',
    type: 'broadcastMessage',
    category: 'paymentTasks',
    message: `Re-inventing the wheel back of the net, nor gain alignment wiggle room. Data-point organic growth. Price point UX big boy pants but please advise soonest so strategic staircase, but curate. Crisp ppt please use "solutionise" instead of solution ideas! :), for high performance keywords or take five, punch the tree, and come back in here with a clear head we want to empower the team with the right tools and guidance to uplevel our craft and build better. Digital literacy.`,
    lastUpdated: '2017-07-23 13:10:11',
    importance: 'standard',
    appCategory: 'MDM',
    opened: false,
    archived: false,
    deletePending: false,
  },
  {
    id: 74467124,
    subject: 'This is the second message from unity',
    type: 'broadcastMessage',
    category: 'paymentTasks',
    message: `Loop back. Looks great, can we try it a different way anti-pattern we need this overall to be busier and more active or beef up, for shelfware into the weeds, yet can we align on lunch orders. Synergestic actionables we don't want to boil the ocean. We need to start advertising on social media i also believe it is important for every member to be involved and invested in our company and this is one way to do so. We need to leverage our synergies optimize the fireball critical mass, yet back to the drawing-board. No scraps hit the floor 360 degree content marketing pool, for customer centric, or fast track strategic staircase. <br> <br> <bold>  Wheelhouse <bold/> this is not the hill i want to die on but what's the real problem we're trying to solve here? eat our own dog food market-facing, yet incentivization. Back of the net bells and whistles diversify <strong>kpis</strong>. &nbsp Re-inventing the wheel back of the net, nor gain alignment wiggle room. Data-point organic growth. Price point UX big boy pants but please advise soonest so strategic staircase, but curate. Crisp ppt please use "solutionise" instead of solution ideas! :), for high performance keywords or take five, punch the tree, and come back in here with a clear head we want to empower the team with the right tools and guidance to uplevel our craft and build better. Digital literacy. <ul> <li>Synergestic actionables we don't want to boil the ocean </li>  <li>Re-inventing the wheel back of the net, nor gain alignment wiggle room 
    </li> <li>Crisp ppt please use "solutionise" instead of solution ideas! </li>  </ul>  `,
    lastUpdated: '2017-07-23 13:10:11',
    importance: 'alert',
    appCategory: 'MDM',
    opened: false,
    archived: false,
    deletePending: false,
  },
  {
    id: 64454124,
    subject: 'Welcome to Unity',
    type: 'broadcastMessage',
    category: 'paymentTasks',
    message: `Re-inventing the wheel back of the net, nor gain alignment wiggle room. Data-point organic growth. Price point UX big boy pants but please advise soonest so strategic staircase, but curate. Crisp ppt please use "solutionise" instead of solution ideas! :), for high performance keywords or take five, punch the tree, and come back in here with a clear head we want to empower the team with the right tools and guidance to uplevel our craft and build better. Digital literacy.`,
    lastUpdated: '2017-07-23 13:10:11',
    importance: 'standard',
    appCategory: 'MDM',
    opened: false,
    archived: false,
    deletePending: false,
  },
  {
    id: 74467124,
    subject: 'This is the second message from unity',
    type: 'broadcastMessage',
    category: 'paymentTasks',
    message: `Loop back. Looks great, can we try it a different way anti-pattern we need this overall to be busier and more active or beef up, for shelfware into the weeds, yet can we align on lunch orders. Synergestic actionables we don't want to boil the ocean. We need to start advertising on social media i also believe it is important for every member to be involved and invested in our company and this is one way to do so. We need to leverage our synergies optimize the fireball critical mass, yet back to the drawing-board. No scraps hit the floor 360 degree content marketing pool, for customer centric, or fast track strategic staircase. Wheelhouse this is not the hill i want to die on but what's the real problem we're trying to solve here? eat our own dog food market-facing, yet incentivization. Back of the net bells and whistles diversify <bold>kpis</bold>. &nbsp Re-inventing the wheel back of the net, nor gain alignment wiggle room. Data-point organic growth. Price point UX big boy pants but please advise soonest so strategic staircase, but curate. Crisp ppt please use "solutionise" instead of solution ideas! :), for high performance keywords or take five, punch the tree, and come back in here with a clear head we want to empower the team with the right tools and guidance to uplevel our craft and build better. Digital literacy.`,
    lastUpdated: '2017-07-23 13:10:11',
    importance: 'alert',
    appCategory: 'MDM',
    opened: false,
    archived: false,
    deletePending: false,
  },
  {
    id: 64454124,
    subject: 'Welcome to Unity',
    type: 'broadcastMessage',
    category: 'paymentTasks',
    message: `Re-inventing the wheel back of the net, nor gain alignment wiggle room. Data-point organic growth. Price point UX big boy pants but please advise soonest so strategic staircase, but curate. Crisp ppt please use "solutionise" instead of solution ideas! :), for high performance keywords or take five, punch the tree, and come back in here with a clear head we want to empower the team with the right tools and guidance to uplevel our craft and build better. Digital literacy.`,
    lastUpdated: '2017-07-23 13:10:11',
    importance: 'standard',
    appCategory: 'MDM',
    opened: false,
    archived: false,
    deletePending: false,
  },
  {
    id: 74467124,
    subject: 'This is the second message from unity',
    type: 'broadcastMessage',
    category: 'paymentTasks',
    message: `Loop back. Looks great, can we try it a different way anti-pattern we need this overall to be busier and more active or beef up, for shelfware into the weeds, yet can we align on lunch orders. Synergestic actionables we don't want to boil the ocean. We need to start advertising on social media i also believe it is important for every member to be involved and invested in our company and this is one way to do so. We need to leverage our synergies optimize the fireball critical mass, yet back to the drawing-board. No scraps hit the floor 360 degree content marketing pool, for customer centric, or fast track strategic staircase. Wheelhouse this is not the hill i want to die on but what's the real problem we're trying to solve here? eat our own dog food market-facing, yet incentivization. Back of the net bells and whistles diversify <bold>kpis</bold>. &nbsp Re-inventing the wheel back of the net, nor gain alignment wiggle room. Data-point organic growth. Price point UX big boy pants but please advise soonest so strategic staircase, but curate. Crisp ppt please use "solutionise" instead of solution ideas! :), for high performance keywords or take five, punch the tree, and come back in here with a clear head we want to empower the team with the right tools and guidance to uplevel our craft and build better. Digital literacy.`,
    lastUpdated: '2017-07-23 13:10:11',
    importance: 'alert',
    appCategory: 'MDM',
    opened: false,
    archived: false,
    deletePending: false,
  },
  {
    id: 64454124,
    subject: 'Welcome to Unity',
    type: 'broadcastMessage',
    category: 'paymentTasks',
    message: `Re-inventing the wheel back of the net, nor gain alignment wiggle room. Data-point organic growth. Price point UX big boy pants but please advise soonest so strategic staircase, but curate. Crisp ppt please use "solutionise" instead of solution ideas! :), for high performance keywords or take five, punch the tree, and come back in here with a clear head we want to empower the team with the right tools and guidance to uplevel our craft and build better. Digital literacy.`,
    lastUpdated: '2017-07-23 13:10:11',
    importance: 'standard',
    appCategory: 'MDM',
    opened: false,
    archived: false,
    deletePending: false,
  },
  {
    id: 74467124,
    subject: 'This is the second message from unity',
    type: 'broadcastMessage',
    category: 'paymentTasks',
    message: `Loop back. Looks great, can we try it a different way anti-pattern we need this overall to be busier and more active or beef up, for shelfware into the weeds, yet can we align on lunch orders. Synergestic actionables we don't want to boil the ocean. We need to start advertising on social media i also believe it is important for every member to be involved and invested in our company and this is one way to do so. We need to leverage our synergies optimize the fireball critical mass, yet back to the drawing-board. No scraps hit the floor 360 degree content marketing pool, for customer centric, or fast track strategic staircase. Wheelhouse this is not the hill i want to die on but what's the real problem we're trying to solve here? eat our own dog food market-facing, yet incentivization. Back of the net bells and whistles diversify <bold>kpis</bold>. &nbsp Re-inventing the wheel back of the net, nor gain alignment wiggle room. Data-point organic growth. Price point UX big boy pants but please advise soonest so strategic staircase, but curate. Crisp ppt please use "solutionise" instead of solution ideas! :), for high performance keywords or take five, punch the tree, and come back in here with a clear head we want to empower the team with the right tools and guidance to uplevel our craft and build better. Digital literacy.`,
    lastUpdated: '2017-07-23 13:10:11',
    importance: 'alert',
    appCategory: 'MDM',
    opened: false,
    archived: false,
    deletePending: false,
  },
];

export const ActivityItems = [
  {
    id: 100,
    activityUser: '<FluentLink to="/"> gregory@redwerks.org </FluentLink>',
    activityDescription: '',
    action: 'comment',
    comments: `
    What about the message from
    <FluentLink to="/"> gregory@redwerks.org </FluentLink>
    where he describes abc?
    `,
    icon: 'MessageIcon',
    demoHour: 0,
  },
  {
    id: 101,
    activityUser: '<FluentLink to="/"> matteo@live.com </FluentLink>',
    activityDescription: '',
    action: 'deleted',
    comments: `
  
    <FluentLink to="/"> matteo@live.com </FluentLink>
    removed <FluentLink to="/"> DocumentTitle.docx</FluentLink>
    `,
    icon: 'DeleteIcon',
    demoHour: 0.5,
  },
  {
    id: 102,
    activityUser: '<FluentLink to="/"> jsmith@gmail.com </FluentLink>',
    activityDescription: '',
    action: 'moved',
    comments: `
    
    <FluentLink to="/"> PresentationTitle.pptx </FluentLink>
    to <FluentLink to="/"> Destination Folder </FluentLink>
    `,
    icon: 'MoveToFolderIcon',
    demoHour: 24,
  },
];

export const UserActivityItems = [
  {
    id: 100,
    activityUser: '<FluentLink to="/"> gregory@redwerks.org </FluentLink>',
    activityDescription: '',
    action: 'comment',
    comments: `
    What about the message from
    <FluentLink to="/"> gregory@redwerks.org </FluentLink>
    where he describes abc?
    `,
    avatar: 'https://material-ui.com/static/images/avatar/1.jpg',
    demoHour: 0,
  },
  {
    id: 101,
    activityUser: '<FluentLink to="/"> matteo@live.com </FluentLink>',
    activityDescription: '',
    action: 'deleted',
    comments: `
  
    <FluentLink to="/"> matteo@live.com </FluentLink>
    removed <FluentLink to="/"> DocumentTitle.docx</FluentLink>
    `,
    icon: 'DeleteIcon',
    demoHour: 0.5,
  },
  {
    id: 102,
    activityUser: '<FluentLink to="/"> jsmith@gmail.com </FluentLink>',
    activityDescription: '',
    action: 'moved',
    comments: `
    
    <FluentLink to="/"> PresentationTitle.pptx </FluentLink>
    to <FluentLink to="/"> Destination Folder </FluentLink>
    `,
    icon: 'MoveToFolderIcon',
    demoHour: 24,
  },
];

export const geojsonObject = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      properties: {
        kind: 'county',
        name: 'Wyandotte',
        state: 'KS',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-94.8627, 39.202],
              [-94.901, 39.202],
              [-94.9, 39.16],
              [-94.8627, 39.1596],
              // [-94.6053, 39.0432],
              // [-94.6053, 39.1144],
              // [-94.5998, 39.1582],
              // [-94.7422, 39.1691],
              // [-94.7751, 39.202],
              // [-94.8627, 39.202],
            ],
          ],
        ],
      },
    },
  ],
};

// export const geojsonObject = {
//   type: 'FeatureCollection',
//   crs: {
//     type: 'name',
//     properties: {
//       name: 'EPSG:3857',
//     },
//   },
//   features: [
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [0, 0],
//       },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'LineString',
//         coordinates: [
//           [4e6, -2e6],
//           [8e6, 2e6],
//         ],
//       },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'LineString',
//         coordinates: [
//           [4e6, 2e6],
//           [8e6, -2e6],
//         ],
//       },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Polygon',
//         coordinates: [
//           [
//             [-5e6, -1e6],
//             [-4e6, 1e6],
//             [-3e6, -1e6],
//           ],
//         ],
//       },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'MultiLineString',
//         coordinates: [
//           [
//             [-1e6, -7.5e5],
//             [-1e6, 7.5e5],
//           ],
//           [
//             [1e6, -7.5e5],
//             [1e6, 7.5e5],
//           ],
//           [
//             [-7.5e5, -1e6],
//             [7.5e5, -1e6],
//           ],
//           [
//             [-7.5e5, 1e6],
//             [7.5e5, 1e6],
//           ],
//         ],
//       },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'MultiPolygon',
//         coordinates: [
//           [
//             [
//               [-5e6, 6e6],
//               [-5e6, 8e6],
//               [-3e6, 8e6],
//               [-3e6, 6e6],
//             ],
//           ],
//           [
//             [
//               [-2e6, 6e6],
//               [-2e6, 8e6],
//               [0, 8e6],
//               [0, 6e6],
//             ],
//           ],
//           [
//             [
//               [1e6, 6e6],
//               [1e6, 8e6],
//               [3e6, 8e6],
//               [3e6, 6e6],
//             ],
//           ],
//         ],
//       },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'GeometryCollection',
//         geometries: [
//           {
//             type: 'LineString',
//             coordinates: [
//               [-5e6, -5e6],
//               [0, -5e6],
//             ],
//           },
//           {
//             type: 'Point',
//             coordinates: [4e6, -5e6],
//           },
//           {
//             type: 'Polygon',
//             coordinates: [
//               [
//                 [-94.9065, 38.9884],
//                 [-95.0544, 38.9829],
//                 [-95.0544, 38.7365],
//                 [-94.9668, 38.7365],
//                 [-94.6108, 38.7365],
//                 [-94.6108, 38.846],
//                 [-94.6053, 39.0432],
//                 [-94.8682, 39.0596],
//                 [-94.9065, 38.9884],
//               ],
//             ],
//           },
//         ],
//       },
//     },
//   ],
// };

export const geojsonObject2 = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      properties: {
        kind: 'county',
        name: 'Johnson',
        state: 'KS',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-94.9065, 38.9884],
              [-95.0544, 38.9829],
              [-95.0544, 38.7365],
              [-94.9668, 38.7365],
              // [-94.6108, 38.7365],
              // [-94.6108, 38.846],
              // [-94.6053, 39.0432],
              // [-94.8682, 39.0596],
              // [-94.9065, 38.9884],
            ],
            // [-94.9627, 39.302],
            // [-95.001, 39.302],
            // [-95.001, 39.16],
            // [-94.9627, 39.2596],
          ],
        ],
      },
    },
  ],
};

export const jsonFeatures = [
  {
    co: [-117.6919133, 34.8201613, 7],
    id: 7,
    title: 'LC: Lorem ipsum dolor sit amet',
    body:
      'Proin pulvinar eleifend orci vel fermentum. Aenean et tellus vel quam luctus.',
  },
  {
    co: [-117.6919133, 35.0201613, 8],
    id: 8,
    title: 'LC: Proin pulvinar',
    body: 'Tellus vel quam luctus commodo vitae. ',
  },
  {
    co: [-117.6919133, 35.0501613, 9],
    id: 9,
    title: 'LC: Praesent consequat venenatis',
    body:
      'Aenean et tellus vel quam luctus commodo vitae vitae tellus. Ac venenatis magna molestie.',
  },
  {
    co: [[-116.6919133, 35.0201613], 10],
    id: 10,
    title: 'LC: Morbi dignissim',
    body:
      'Curabitur finibus sapien et enim mattis, ac venenatis magna molestie.',
  },
  {
    co: [-119.6919133, 35.0201613, 11],
    id: 11,
    title: 'LC: Aliquam libero massa,',
    body: 'Sapien et enim mattis, ac venenatis magna molestie.',
  },
  {
    co: [-120.6919133, 33.9201613, 12],
    id: 12,
    title: 'LC: Quisque ullamcorper',
    body: 'Finibus sapien et enim mattis, ac venenatis magna molestie.',
  },
];

export const alertFeatures = [
  {
    co: [-117.6919133, 34.8201613, 7, 'ALT'],
    id: 7,
    title: 'Lorem ipsum dolor sit amet',
    body:
      'Proin pulvinar eleifend orci vel fermentum. Aenean et tellus vel quam luctus.',
  },
  {
    co: [-115.6919133, 34.7201613, 8, 'ALT'],
    id: 8,
    title: 'Proin pulvinar',
    body: 'Tellus vel quam luctus commodo vitae. ',
  },
  {
    co: [-114.6919133, 34.9501613, 9, 'ALT'],
    id: 9,
    title: 'Praesent consequat venenatis',
    body:
      'Aenean et tellus vel quam luctus commodo vitae vitae tellus. Ac venenatis magna molestie.',
  },
  {
    co: [-119.6919133, 34.7201613, 10, 'ALT'],
    id: 10,
    title: 'Morbi dignissim',
    body:
      'Curabitur finibus sapien et enim mattis, ac venenatis magna molestie.',
  },
  {
    co: [-120.6919133, 35.0201613, 11, 'ALT'],
    id: 11,
    title: 'Aliquam libero massa,',
    body: 'Sapien et enim mattis, ac venenatis magna molestie.',
  },
  {
    co: [-121.6919133, 34.9201613, 12, 'ALT'],
    id: 12,
    title: 'Quisque ullamcorper',
    body: 'Finibus sapien et enim mattis, ac venenatis magna molestie.',
  },
];

export const mockMenus = [
  {
    menuInstanceId: '40260615-aa79-499e-9b35-92d1409b4b6c',
    name: 'Fleet Management Left Menu',
    verticalId: null,
    menuTypeId: 1,
    productId: 6,
    default: false,
    displayOrder: 1,
    active: true,
    menuItemInstanceStructureViews: [
      {
        menuStructureId: 956,
        menuItemInstance: {
          menuItemInstanceId: 'b02fc1f6-2b3c-4d9f-976b-6751ac67c447',
          clusterId: 963,
          menuItemId: 'ec5f1c26-e7e1-4f19-8e6e-143308995a40',
          name: 'Fleet Order',
          parameters:
            '{"FluentIcon":"FileSymlinkIcon","AppIcon":"","Label":"Fleet Order","Slug":"/FleetOrder","RedirectURL":"","i18n":""}',
          productId: null,
          isActive: true,
          roleIds: [],
          items: null,
        },
        title: 'Fleet Order',
        order: 0,
        parentId: null,
        menuItemInstanceStructures: [],
      },
      {
        menuStructureId: 957,
        menuItemInstance: {
          menuItemInstanceId: 'd93502a5-f0ac-4338-b0d1-1004738fb1f2',
          clusterId: 964,
          menuItemId: 'ec5f1c26-e7e1-4f19-8e6e-143308995a40',
          name: 'Equipment',
          parameters:
            '{"FluentIcon":"FileSymlinkIcon","AppIcon":"","Label":"Equipment","Slug":"/Equipment","RedirectURL":"","i18n":""}',
          productId: null,
          isActive: true,
          roleIds: [],
          items: null,
        },
        title: 'Equipment',
        order: 1,
        parentId: null,
        menuItemInstanceStructures: [],
      },
      {
        menuStructureId: 958,
        menuItemInstance: {
          menuItemInstanceId: 'a04c63b5-5003-4f08-9910-165664059d4d',
          clusterId: 965,
          menuItemId: 'ec5f1c26-e7e1-4f19-8e6e-143308995a40',
          name: 'Stock',
          parameters:
            '{"FluentIcon":"FileSymlinkIcon","AppIcon":"","Label":"Stock","Slug":"/Stock","RedirectURL":"","i18n":""}',
          productId: null,
          isActive: true,
          roleIds: [],
          items: null,
        },
        title: 'Stock',
        order: 2,
        parentId: null,
        menuItemInstanceStructures: [],
      },
      {
        menuStructureId: 959,
        menuItemInstance: {
          menuItemInstanceId: 'ad7481b8-ddcd-4536-af22-97f9feb587c9',
          clusterId: 966,
          menuItemId: 'ec5f1c26-e7e1-4f19-8e6e-143308995a40',
          name: 'Construction Units',
          parameters:
            '{"FluentIcon":"FileSymlinkIcon","AppIcon":"","Label":"Construction Units","Slug":"/ConstructionUnits","RedirectURL":"","i18n":""}',
          productId: null,
          isActive: true,
          roleIds: [],
          items: null,
        },
        title: 'Construction Units',
        order: 3,
        parentId: null,
        menuItemInstanceStructures: [],
      },
      {
        menuStructureId: 960,
        menuItemInstance: {
          menuItemInstanceId: 'd0c31027-0d0b-4456-9abd-245b1c8fb71e',
          clusterId: 967,
          menuItemId: 'b36cec3c-fe05-47ed-a687-70be22b0e200',
          name: 'Configuration',
          parameters:
            '{"FluentIcon":"FabricFolderIcon","AppIcon":"","Label":"Configuration","Slug":"","RedirectURL":"","i18n":""}',
          productId: null,
          isActive: true,
          roleIds: [],
          items: null,
        },
        title: 'Configuration',
        order: 4,
        parentId: null,
        menuItemInstanceStructures: [
          {
            menuStructureId: 961,
            menuItemInstance: {
              menuItemInstanceId: '35c7e54f-018b-4c17-805e-ff60cf5de17f',
              clusterId: 968,
              menuItemId: 'ec5f1c26-e7e1-4f19-8e6e-143308995a40',
              name: 'Alias',
              parameters:
                '{"FluentIcon":"FileSymlinkIcon","AppIcon":"","Label":"Alias","Slug":"/Alias","RedirectURL":"","i18n":""}',
              productId: null,
              isActive: true,
              roleIds: [],
              items: null,
            },
            title: 'Alias',
            order: 0,
            parentId: 960,
            menuItemInstanceStructures: [],
          },
          {
            menuStructureId: 962,
            menuItemInstance: {
              menuItemInstanceId: '594e6c46-6fff-4d43-b0b7-18b51b854fb8',
              clusterId: 969,
              menuItemId: 'ec5f1c26-e7e1-4f19-8e6e-143308995a40',
              name: 'Fuel Code',
              parameters:
                '{"FluentIcon":"FileSymlinkIcon","AppIcon":"","Label":"Fuel Code","Slug":"/FuelCode","RedirectURL":"","i18n":""}',
              productId: null,
              isActive: true,
              roleIds: [],
              items: null,
            },
            title: 'Fuel Code',
            order: 1,
            parentId: 960,
            menuItemInstanceStructures: [],
          },
          {
            menuStructureId: 963,
            menuItemInstance: {
              menuItemInstanceId: 'b0331201-dfc2-4508-9268-4cbc96a856b7',
              clusterId: 970,
              menuItemId: 'ec5f1c26-e7e1-4f19-8e6e-143308995a40',
              name: 'Task',
              parameters:
                '{"FluentIcon":"FileSymlinkIcon","AppIcon":"","Label":"Task","Slug":"/Task","RedirectURL":"","i18n":""}',
              productId: null,
              isActive: true,
              roleIds: [],
              items: null,
            },
            title: 'Task',
            order: 2,
            parentId: 960,
            menuItemInstanceStructures: [],
          },
          {
            menuStructureId: 964,
            menuItemInstance: {
              menuItemInstanceId: '4a46a7ea-07f3-4648-be9c-1614eae634ed',
              clusterId: 971,
              menuItemId: 'ec5f1c26-e7e1-4f19-8e6e-143308995a40',
              name: 'Task List',
              parameters:
                '{"FluentIcon":"FileSymlinkIcon","AppIcon":"","Label":"Task List","Slug":"/TaskList","RedirectURL":"","i18n":""}',
              productId: null,
              isActive: true,
              roleIds: [],
              items: null,
            },
            title: 'Task List',
            order: 3,
            parentId: 960,
            menuItemInstanceStructures: [],
          },
          {
            menuStructureId: 965,
            menuItemInstance: {
              menuItemInstanceId: 'eee375df-b1f1-4406-ad85-d2cfc34f93d4',
              clusterId: 972,
              menuItemId: 'ec5f1c26-e7e1-4f19-8e6e-143308995a40',
              name: 'Part Kit',
              parameters:
                '{"FluentIcon":"FileSymlinkIcon","AppIcon":"","Label":"Part Kit","Slug":"/PartKit","RedirectURL":"","i18n":""}',
              productId: null,
              isActive: true,
              roleIds: [],
              items: null,
            },
            title: 'Part Kit',
            order: 4,
            parentId: 960,
            menuItemInstanceStructures: [],
          },
          {
            menuStructureId: 966,
            menuItemInstance: {
              menuItemInstanceId: 'c942f557-108d-4a0c-a193-49876be63685',
              clusterId: 973,
              menuItemId: 'ec5f1c26-e7e1-4f19-8e6e-143308995a40',
              name: 'GL Account',
              parameters:
                '{"FluentIcon":"FileSymlinkIcon","AppIcon":"","Label":"GL Account","Slug":"/GLAccount","RedirectURL":"","i18n":""}',
              productId: null,
              isActive: true,
              roleIds: [],
              items: null,
            },
            title: 'GL Account',
            order: 5,
            parentId: 960,
            menuItemInstanceStructures: [],
          },
          {
            menuStructureId: 967,
            menuItemInstance: {
              menuItemInstanceId: 'beb07ef2-642f-4af8-aaea-4177d5d4c9e9',
              clusterId: 974,
              menuItemId: 'ec5f1c26-e7e1-4f19-8e6e-143308995a40',
              name: 'List Code',
              parameters:
                '{"FluentIcon":"FileSymlinkIcon","AppIcon":"","Label":"List Code","Slug":"/ListCode","RedirectURL":"","i18n":""}',
              productId: null,
              isActive: true,
              roleIds: [],
              items: null,
            },
            title: 'List Code',
            order: 6,
            parentId: 960,
            menuItemInstanceStructures: [],
          },
          {
            menuStructureId: 968,
            menuItemInstance: {
              menuItemInstanceId: 'db751559-4bde-4724-ab81-d97ee1a31e9d',
              clusterId: 975,
              menuItemId: 'ec5f1c26-e7e1-4f19-8e6e-143308995a40',
              name: 'Unit of Measure',
              parameters:
                '{"FluentIcon":"FileSymlinkIcon","AppIcon":"","Label":"Unit of Measure","Slug":"/UnitofMeasure","RedirectURL":"","i18n":""}',
              productId: null,
              isActive: true,
              roleIds: [],
              items: null,
            },
            title: 'Unit of Measure',
            order: 7,
            parentId: 960,
            menuItemInstanceStructures: [],
          },
          {
            menuStructureId: 969,
            menuItemInstance: {
              menuItemInstanceId: '9e73ea85-fe71-4e27-9ae6-171fc0ee983b',
              clusterId: 976,
              menuItemId: 'ec5f1c26-e7e1-4f19-8e6e-143308995a40',
              name: 'Warehouse',
              parameters:
                '{"FluentIcon":"FileSymlinkIcon","AppIcon":"","Label":"Warehouse","Slug":"/Warehouse","RedirectURL":"","i18n":""}',
              productId: null,
              isActive: true,
              roleIds: [],
              items: null,
            },
            title: 'Warehouse',
            order: 8,
            parentId: 960,
            menuItemInstanceStructures: [],
          },
          {
            menuStructureId: 970,
            menuItemInstance: {
              menuItemInstanceId: '9e73ea85-fe71-4e27-9ae6-171fc0ee983b',
              clusterId: 977,
              menuItemId: 'ec5f1c26-e7e1-4f19-8e6e-143308995a40',
              name: 'Import',
              parameters:
                '{"FluentIcon":"FileSymlinkIcon","AppIcon":"","Label":"Import","Slug":"/Import","RedirectURL":"","i18n":""}',
              productId: null,
              isActive: true,
              roleIds: [],
              items: null,
            },
            title: 'Import',
            order: 9,
            parentId: 960,
            menuItemInstanceStructures: [],
          },
          {
            menuStructureId: 971,
            menuItemInstance: {
              menuItemInstanceId: '9e73ea85-fe71-4e27-9ae6-171fc0ee983b',
              clusterId: 978,
              menuItemId: 'ec5f1c26-e7e1-4f19-8e6e-143308995a40',
              name: 'Import',
              parameters:
                '{"FluentIcon":"FileSymlinkIcon","AppIcon":"","Label":"Import View","Slug":"/ImportView","RedirectURL":"","i18n":""}',
              productId: null,
              isActive: true,
              roleIds: [],
              items: null,
            },
            title: 'Import',
            order: 10,
            parentId: 960,
            menuItemInstanceStructures: [],
          },
        ],
      },
    ],
  },
];
